import React, { useEffect, useState } from "react";
import {
  useNavigate,
  Link,
  useSearchParams,
} from "react-router-dom";
import { Button, Container, Card } from "react-bootstrap";
import {
  getVendor,
  deleteVendor,
} from "../../store/slices/vendor";
import DeleteModal from "./deletepopup";
import { useDispatch, useSelector } from "react-redux";
import {
  FaEdit,
  FaTrash,
  FaSearch,
  FaFilter,
  FaRedoAlt,
  FaUserTie,
  FaPhone,
  FaEnvelope,
} from "react-icons/fa";

export default function Vendor() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {
    vendorList = [],
    loading,
  } = useSelector((state) => state.vendor);

  const [showDelete, setShowDelete] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [deleteStatus, setDeleteStatus] = useState("confirm");
  const [searchParams, setSearchParams] =
    useSearchParams();

  const search =
    searchParams.get("search") || "";

  const service =
    searchParams.get("service") || "";

  const currentPage = Number(
    searchParams.get("page") || 1
  );
  const itemsPerPage = 20;

  useEffect(() => {
    const params = {
      page: currentPage,
      limit: itemsPerPage,
    };

    if (search) {
      params.search = search;
    }

    if (service) {
      params.service = service;
    }

    dispatch(getVendor(params));
  }, [
    dispatch,
    currentPage,
    search,
    service,
  ]);

  const handleConfirmDelete = async () => {
    try {
      setDeleteStatus("loading");

      await dispatch(
        deleteVendor(selectedId)
      ).unwrap();

      setDeleteStatus("success");

      setTimeout(() => {
        setShowDelete(false);
        setDeleteStatus("confirm");
      }, 1500);
    } catch (error) {
      setDeleteStatus("confirm");
    }
  };

  const totalPages = Math.ceil(
    (vendorList?.total || 0) / itemsPerPage
  );

  const currentVendors =
    vendorList?.vendors || [];

  const updateFilters = ({
    search: newSearch = search,
    service: newService = service,
    page = 1,
  }) => {
    const params = {};

    if (newSearch) {
      params.search = newSearch;
    }

    if (newService) {
      params.service = newService;
    }

    if (page > 1) {
      params.page = page;
    }

    setSearchParams(params);
  };

  const changePage = (pageNumber) => {
    if (
      pageNumber >= 1 &&
      pageNumber <= totalPages
    ) {
      updateFilters({
        page: pageNumber,
      });
    }
  };

  const handleReset = () => {
    setSearchParams({});
  };

  return (
    <>
      {/* ================= BREADCRUMB ================= */}

      <div className="breadcrumb-bar mb-2">

        <div className="breadcrumb-left">

          <Link
            to="/admin/home"
            className="breadcrumb-link active"
          >
            Home
          </Link>

          <span className="breadcrumb-separator">
            |
          </span>

          <span className="breadcrumb-link inactive">
            Service Providers
          </span>

        </div>

        <button
          className="add-outlet-btn"
          onClick={() =>
            navigate("/admin/addvendor")
          }
        >
          + Add New
        </button>

      </div>


      {/* ================= CONTENT ================= */}

      <Container fluid className="mb-5">

        <Card className="table-border">

          <Card.Body>

            {/* ================= FILTER ================= */}

            <div className="guests-table-wrapper common-table-wrapper py-2">

              <div className="d-flex gap-2 mb-3 align-items-center flex-wrap">

                {/* SEARCH */}
                <div
                  className="position-relative ms-2"
                  style={{
                    maxWidth: "250px",
                    width: "100%",
                  }}
                >
                  <FaSearch
                    className="position-absolute"
                    style={{
                      left: "12px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      color: "#999",
                      fontSize: "12px",
                      zIndex: 2,
                      pointerEvents: "none",
                    }}
                  />

                  <input
                    type="text"
                    className="form-control vendor-search-input"
                    placeholder="Search name, email, mobile"
                    value={search}
                    onChange={(e) => {
                      updateFilters({
                        search: e.target.value,
                        page: 1,
                      });
                    }}
                  />
                </div>

                {/* SERVICE FILTER */}

                <div
                  className="position-relative"
                  style={{
                    maxWidth: "200px",
                    width: "100%",
                  }}
                >

                  <FaFilter
                    className="position-absolute"
                    style={{
                      left: "12px",
                      top: "50%",
                      transform:
                        "translateY(-50%)",
                      color: "#999",
                      fontSize: "11px",
                      zIndex: 2,
                    }}
                  />

                  <select
                    className="form-select vendor-search-input"
                    value={service}
                    onChange={(e) => {
                      updateFilters({
                        service: e.target.value,
                        page: 1,
                      });
                    }}
                    style={{
                      paddingLeft: "32px",
                    }}
                  >
                    <option value="">
                      All Services
                    </option>

                    <option value="VEHICLE">
                      Vehicle
                    </option>

                    <option value="HOTEL">
                      Hotel
                    </option>

                    <option value="FERRY">
                      Ferry
                    </option>

                    <option value="ACTIVITY">
                      Activity
                    </option>
                  </select>

                </div>


                {/* RESET */}

                <button
                  className="cancel-btn"
                  onClick={handleReset}
                >
                  <FaRedoAlt
                    size={10}
                    className="me-1"
                  />

                  Reset
                </button>

              </div>


              {/* ================= TABLE ================= */}

              <div className="table-responsive">

                <table className="table guests-table common-table align-middle">

                  <thead>

                    <tr>

                      <th className="text-center">
                        #
                      </th>

                      <th className="text-center">
                        Name
                      </th>

                      <th className="text-center">
                        Contact Person
                      </th>

                      <th className="text-center">
                        Mobile
                      </th>

                      <th className="text-center">
                        Email
                      </th>

                      <th className="text-center">
                        Services
                      </th>

                      <th className="text-center">
                        Action
                      </th>

                    </tr>

                  </thead>


                  <tbody>

                    {/* ================= LOADING ================= */}

                    {loading ? (

                      [...Array(6)].map(
                        (_, index) => (

                          <tr key={index}>

                            <td className="text-center">

                              <div className="skeleton skeleton-text small" />

                            </td>


                            <td className="text-center">

                              <div className="d-flex align-items-center justify-content-center gap-2">

                                <div className="skeleton skeleton-image" />

                                <div
                                  className="skeleton skeleton-text"
                                  style={{
                                    width: "80px",
                                  }}
                                />

                              </div>

                            </td>


                            <td className="text-center">

                              <div className="skeleton skeleton-text" />

                            </td>


                            <td className="text-center">

                              <div className="skeleton skeleton-text" />

                            </td>


                            <td className="text-center">

                              <div className="skeleton skeleton-text" />

                            </td>


                            <td className="text-center">

                              <div className="d-flex justify-content-center gap-1">

                                <div className="skeleton skeleton-btn" />

                                <div className="skeleton skeleton-btn" />

                              </div>

                            </td>


                            <td className="text-center">

                              <div className="d-flex justify-content-center gap-2">

                                <div className="skeleton skeleton-btn" />

                                <div className="skeleton skeleton-btn" />

                              </div>

                            </td>

                          </tr>

                        )
                      )

                    ) : currentVendors.length > 0 ? (

                      /* ================= DATA ================= */

                      currentVendors.map(
                        (vendor, index) => (

                          <tr
                            key={vendor._id}
                          >

                            {/* NUMBER */}

                            <td className="text-center">

                              {(currentPage -
                                1) *
                                itemsPerPage +
                                index +
                                1}

                            </td>


                            {/* NAME */}

                            <td className="text-center">

                              <div className="d-flex align-items-center justify-content-center gap-2">


                                <span>
                                  {vendor?.name ||
                                    "-"}
                                </span>

                              </div>

                            </td>


                            {/* CONTACT */}

                            <td className="text-center">

                              <div className="d-flex align-items-center justify-content-center gap-1">


                                <span>
                                  {vendor?.contactPerson ||
                                    "-"}
                                </span>

                              </div>

                            </td>


                            {/* MOBILE */}

                            <td className="text-center">

                              <div className="d-flex align-items-center justify-content-center gap-1">



                                <span>
                                  {vendor?.mobileNumber ||
                                    "-"}
                                </span>

                              </div>

                            </td>


                            {/* EMAIL */}

                            <td className="text-center">

                              <div className="d-flex align-items-center justify-content-center gap-1">



                                <span>
                                  {vendor?.email ||
                                    "-"}
                                </span>

                              </div>

                            </td>


                            {/* SERVICES */}

                            <td className="text-center">

                              {vendor?.services
                                ?.length ? (

                                <div className="d-flex justify-content-center gap-1 flex-wrap">

                                  {vendor.services.map(
                                    (
                                      item,
                                      serviceIndex
                                    ) => (

                                      <span
                                        key={
                                          serviceIndex
                                        }
                                        className="badge rounded-pill"
                                        style={{
                                          background:
                                            "#f0eafa",
                                          color:
                                            "#5d3c8b",
                                          fontSize:
                                            "9px",
                                          padding:
                                            "5px 8px",
                                        }}
                                      >
                                        {item}
                                      </span>

                                    )
                                  )}

                                </div>

                              ) : (

                                <span className="text-muted small">
                                  -
                                </span>

                              )}

                            </td>


                            {/* ACTION */}

                            <td className="text-center">

                              <div className="action-btn-group d-flex justify-content-center gap-2">

                                {/* EDIT */}

                                <button
                                  type="button"
                                  onClick={() =>
                                    navigate(
                                      `/admin/editvendor/${vendor._id}`
                                    )
                                  }
                                  className="action-btn edit-btn"
                                  title="Edit"
                                >
                                  <FaEdit
                                    size={14}
                                  />
                                </button>


                                {/* DELETE */}

                                <button
                                  type="button"
                                  className="action-btn delete-btn"
                                  title="Delete"
                                  onClick={() => {
                                    setSelectedId(
                                      vendor._id
                                    );
                                    setShowDelete(
                                      true
                                    );
                                  }}
                                >
                                  <FaTrash
                                    size={14}
                                  />
                                </button>

                              </div>

                            </td>

                          </tr>

                        )

                      )

                    ) : (

                      /* ================= EMPTY ================= */

                      <tr>

                        <td
                          colSpan="7"
                          className="text-center py-5"
                        >

                          <div className="text-muted">

                            <FaUserTie
                              size={30}
                              style={{
                                opacity: 0.35,
                                marginBottom:
                                  "10px",
                              }}
                            />

                            <div className="fw-semibold">
                              No service providers found
                            </div>

                            <div
                              className="small mt-1"
                            >
                              Try changing your
                              search or service
                              filter.
                            </div>

                          </div>

                        </td>

                      </tr>

                    )}

                  </tbody>

                </table>

              </div>

            </div>


            {/* ================= PAGINATION ================= */}

            {!loading &&
              totalPages > 1 && (

                <div className="d-flex justify-content-center align-items-center gap-2 mt-4 flex-wrap">

                  <Button
                    variant="light"
                    disabled={
                      currentPage === 1
                    }
                    onClick={() =>
                      changePage(
                        currentPage - 1
                      )
                    }
                  >
                    ‹
                  </Button>


                  {Array.from(
                    {
                      length: totalPages,
                    },
                    (_, i) => i + 1
                  )
                    .filter((page) => {

                      return (
                        page === 1 ||
                        page === totalPages ||
                        Math.abs(
                          page -
                          currentPage
                        ) <= 1
                      );

                    })
                    .map(
                      (
                        page,
                        index,
                        arr
                      ) => {

                        const prevPage =
                          arr[index - 1];

                        return (
                          <div
                            key={page}
                            className="d-flex align-items-center gap-2"
                          >

                            {prevPage &&
                              page -
                              prevPage >
                              1 && (
                                <span>
                                  ...
                                </span>
                              )}

                            <Button
                              variant={
                                currentPage ===
                                  page
                                  ? "dark"
                                  : "light"
                              }
                              onClick={() =>
                                changePage(
                                  page
                                )
                              }
                            >
                              {page}
                            </Button>

                          </div>
                        );

                      }
                    )}


                  <Button
                    variant="light"
                    disabled={
                      currentPage ===
                      totalPages
                    }
                    onClick={() =>
                      changePage(
                        currentPage + 1
                      )
                    }
                  >
                    ›
                  </Button>

                </div>

              )}

          </Card.Body>

        </Card>

      </Container>


      {/* ================= DELETE MODAL ================= */}

      <DeleteModal
        show={showDelete}
        onHide={() => {
          setShowDelete(false);
          setDeleteStatus("confirm");
        }}
        onConfirm={
          handleConfirmDelete
        }
        status={deleteStatus}
      />

    </>
  );
}